import {
  useCallback,
  useMemo,
} from 'react';
import {
  useLocation,
  useNavigate,
  useSearchParams as useRrSearchParams,
} from 'react-router-dom';

/** Vite SPA 对 `next/navigation` 的 shim，让现有客户端组件可复用。 */
export function usePathname() {
  return useLocation().pathname;
}

export function useRouter() {
  const navigate = useNavigate();
  return useMemo(
    () => ({
      push: (href: string) => {
        navigate(href);
      },
      replace: (href: string) => {
        navigate(href, { replace: true });
      },
      back: () => {
        navigate(-1);
      },
      forward: () => {
        navigate(1);
      },
      prefetch: () => undefined,
      refresh: () => undefined,
    }),
    [navigate],
  );
}

export function useSearchParams() {
  const [params] = useRrSearchParams();
  const get = useCallback((name: string) => params.get(name), [params]);
  return useMemo(() => {
    return {
      get,
      toString: () => params.toString(),
      entries: () => params.entries(),
      keys: () => params.keys(),
      values: () => params.values(),
      has: (name: string) => params.has(name),
      forEach: (
        cb: (value: string, key: string, parent: URLSearchParams) => void,
      ) => params.forEach(cb),
    };
  }, [get, params]);
}
